import {
  CREATE_SEARCH_QUERY,
  DELETE_SEARCH_QUERY,
  GET_SEARCH_QUERIES,
  SEARCH_BOARDS,
  SEARCH_FORMS,
  UPDATE_SEARCH_QUERY,
  SELECT_QUERY,
} from '../../state/actionTypes';
import { convertQueryToOpenSearchQuery, getMostRecentDateFields } from '../searchHelpers';
import SearchService from './search.service';

export const getQueries = (type) => async (dispatch) => {
  const { data } = await SearchService.getQueries(type);
  if (!data) return false;
  dispatch({
    type: GET_SEARCH_QUERIES,
    payload: {
      queries: data,
      type,
    },
  });
  return true;
};

export const createQuery = (payload, type) => async (dispatch) => {
  const { data } = await SearchService.createQuery(payload);
  if (!data) return false;
  dispatch({
    type: CREATE_SEARCH_QUERY,
    payload: {
      query: data,
      type,
    },
  });
  return data;
};

export const updateQuery = (id, payload, type) => async (dispatch) => {
  const { data } = await SearchService.updateQuery(id, payload);
  if (!data) return false;
  dispatch({
    type: UPDATE_SEARCH_QUERY,
    payload: {
      query: {
        id,
        ...payload,
      },
      type,
    },
  });
  return true;
};

export const deleteQuery = (id, type) => async (dispatch) => {
  const { data } = await SearchService.deleteQuery(id);
  if (!data) return false;
  dispatch({
    type: DELETE_SEARCH_QUERY,
    payload: {
      id,
      type,
    },
  });
  return true;
};

export const searchForms = ({
  query,
  selectedQuery,
  filterType,
  analyticsFieldIds = [],
}) => async (dispatch) => {
  const mostRecentDateFields = getMostRecentDateFields(query?.formulas);
  const openSearchQuery = convertQueryToOpenSearchQuery(query, filterType);
  const payload = {
    query: openSearchQuery,
    queryId: selectedQuery?.id,
    templateId: query?.templateId,
    mostRecentDateFields,
    analyticsFieldIds,
  };
  const { data } = await SearchService.searchForms(payload);
  if (!data) return false;

  const results = analyticsFieldIds.length > 0 ? data.results : data;
  const formFieldValues = data.formFieldValues || {};

  dispatch({
    type: SEARCH_FORMS,
    payload: {
      results,
      selectedQuery,
      formFieldValues,
      currentQuery: {
        query: { ...query },
        type: 'forms',
        filterType,
        selectedQueryId: selectedQuery?.id,
      },
    },
  });
  return true;
};

export const searchBoards = ({
  query,
  selectedQuery,
  filterType,
  analyticsFieldIds = [],
}) => async (dispatch) => {
  const mostRecentDateFields = getMostRecentDateFields(query?.formulas);
  const openSearchQuery = convertQueryToOpenSearchQuery(query, filterType);
  const { data } = await SearchService.searchBoards({
    query: openSearchQuery,
    queryId: selectedQuery?.id,
    cardTypeId: query?.cardTypeId,
    boardIds: query?.boardIds,
    mostRecentDateFields,
    analyticsFieldIds,
  });
  if (!data) return false;
  const results = analyticsFieldIds.length > 0 ? data.results : data;
  const formFieldValues = data.formFieldValues || {};
  dispatch({
    type: SEARCH_BOARDS,
    payload: {
      results,
      selectedQuery,
      cardTypeId: query?.cardTypeId,
      formFieldValues,
      currentQuery: {
        query: { ...query },
        type: 'boards',
        filterType,
        selectedQueryId: selectedQuery?.id,
      },
    },
  });
  return true;
};

export const selectQuery = (selectedQuery) => async (dispatch) => {
  const prom = selectedQuery.type === 'boards'
    ? SearchService.searchBoards
    : SearchService.searchForms;

  const mostRecentDateFields = getMostRecentDateFields(
    selectedQuery?.query?.formulas,
  );

  const analyticsFieldIds = (selectedQuery?.query?.formulas ?? [])
    .filter((f) => f.analytics)
    .map((f) => f.field);

  const payload = {
    query: selectedQuery.query,
    queryId: selectedQuery.id,
    mostRecentDateFields,
    analyticsFieldIds,
  };

  payload.query = convertQueryToOpenSearchQuery(selectedQuery?.query, selectedQuery.filterType);

  if (selectedQuery.type === 'forms') {
    payload.templateId = selectedQuery.query?.templateId;
  } else {
    payload.cardTypeId = selectedQuery.query?.cardTypeId;
    payload.boardIds = selectedQuery.query?.boardIds;
  }

  const { data } = await prom(payload);

  if (!data) return false;

  const results = analyticsFieldIds.length > 0 ? data.results : data;
  const formFieldValues = data.formFieldValues || {};

  dispatch({
    type: SELECT_QUERY,
    payload: {
      selectedQuery,
      results,
      formFieldValues,
    },
  });
  return true;
};

export const clearSelectedQuery = () => ({
  type: SELECT_QUERY,
  payload: {
    selectedQuery: null,
    results: [],
    formFieldValues: {},
  },
});
